import { NotificationsMenu } from "../layout/NotificationsMenu";
import { MessagesMenu } from "../layout/MessagesMenu";
import { useNotificationsFeed } from "../../contexts/NotificationsFeedContext";
import { useMessagesFeed } from "../../contexts/MessagesFeedContext";
import "../../styles/notifications.css";
import "../../styles/inputs.css";

export const NotificationsBadgesBlog = () => {
  const { showBellDot, unreadNotificationsCount, notificationsList } =
    useNotificationsFeed();
  const { showMessageDot, unreadMessagesCount, messagesList } =
    useMessagesFeed();
  const messagesCountLabel =
    unreadMessagesCount > 99 ? "99+" : unreadMessagesCount;
  const notificationsCountLabel =
    unreadNotificationsCount > 99 ? "99+" : unreadNotificationsCount;

  return (
    <div className="nb-badges">
      <div className="nb-pill nb-click">
        {unreadMessagesCount > 0 ? (
          <span className="nb-count">{messagesCountLabel}</span>
        ) : (
          showMessageDot && <span className="nb-dot" />
        )}
        <MessagesMenu messages={messagesList} />
      </div>

      <div className="nb-pill nb-click">
        {unreadNotificationsCount > 0 ? (
          <span className="nb-count">{notificationsCountLabel}</span>
        ) : (
          showBellDot && <span className="nb-dot" />
        )}
        <NotificationsMenu notifications={notificationsList} />
      </div>
    </div>
  );
};
